import { Directive, TemplateRef } from '@angular/core';

@Directive({
  standalone: true,
  selector: '[rtSelectFooter]',
})
export class Select2FooterDirective {
  constructor(public templateRef: TemplateRef<void>) {}
}
